@if (successfullSubmitted) {
  @if (successMessage()) {
    <div class="row">
      <div class="col-xs-12 mb-3">
        <div class="p-3 msg-success">{{ successMessage() }}</div>
      </div>
    </div>
  }
} @else if (! order()) {
  <form novalidate [formGroup]="form" (ngSubmit)="findOrder()">
    <p>Bitte gib deine Bestellnummer und die E-Mail-Adresse an, mit der du bestellt hast.</p>
    <div class="row">
      <div class="col-xs-12 mb-3">
        <label class="form-label">Bestellnummer</label>
        <div class="order-number-fields d-flex align-items-center">
          <span class="input-wrap" [class.invalid]="form.controls['orderNumberPart1'].invalid && form.controls['orderNumberPart1'].touched"
            [class.valid]="form.controls['orderNumberPart1'].valid && form.controls['orderNumberPart1'].touched"
            >
            <input type="text" inputmode="numeric" maxlength="4" class="form-control" formControlName="orderNumberPart1"
              placeholder="XXXX" (paste)="onOrderNumberPaste($event)">
          </span>
          <span class="order-number-sep">-</span>
          <span class="input-wrap" [class.invalid]="form.controls['orderNumberPart2'].invalid && form.controls['orderNumberPart2'].touched"
            [class.valid]="form.controls['orderNumberPart2'].valid && form.controls['orderNumberPart2'].touched"
            >
            <input type="text" inputmode="numeric" maxlength="4" class="form-control" formControlName="orderNumberPart2"
              placeholder="XXXX" (paste)="onOrderNumberPaste($event)">
          </span>
          <span class="order-number-sep">-</span>
          <span class="input-wrap" [class.invalid]="form.controls['orderNumberPart3'].invalid && form.controls['orderNumberPart3'].touched"
            [class.valid]="form.controls['orderNumberPart3'].valid && form.controls['orderNumberPart3'].touched"
            >
            <input type="text" inputmode="numeric" maxlength="6" class="form-control" formControlName="orderNumberPart3"
              placeholder="XXXXXX" (paste)="onOrderNumberPaste($event)">
          </span>
        </div>
        @if (orderNumberInvalid()) {
          <div class="form-field-error">
            <div>Bitte gib die Bestellnummer im Format XXXX-XXXX-XXXXXX (mit führenden Nullen) an.</div>
          </div>
        }
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 mb-3">
        <span class="input-wrap" [class.invalid]="form.controls['email'].invalid && form.controls['email'].touched"
          [class.valid]="form.controls['email'].valid && form.controls['email'].touched"
          >
          <input placeholder="E-Mail-Adresse" type="email" class="form-control" formControlName="email">
        </span>
        <show-form-error text="E-Mail-Adresse" path="email"></show-form-error>
      </div>
    </div>
    @if (errorMessage()) {
      <div class="row">
        <div class="col-xs-12 mb-3">
          <div class="p-3 msg-error">{{ errorMessage() }}</div>
        </div>
      </div>
    }
    <button type="submit" class="btn btn-green" [disabled]="loading() || ! form.valid">
      @if (loading()) {
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      }
      Bestellung suchen
    </button>
  </form>
} @else {
  <p><strong>Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus.</strong></p>
  <p>Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über den Kauf der folgenden Waren (*)/die Erbringung der folgenden Dienstleistung (*).<br />
  </p>
  <p>Für die Rückgabe stehen dir derzeit zwei mögliche Wege zur Verfügung.
    <ol>
    <li>Du sendest die Produkte über den normalen Postweg an uns. Bitte beachte, dass du als Kunde die Kosten der Rücksendung zu tragen hast!<br >
      <address>
        Waldviertler Werkstätten<br />
        Rückgabe Webshop<br />
        Niederschremser Straße 4b<br />
        3943 Schrems
      </address>
    </li>
    <li>Du übergibst die Produkte in einem unserer GEA Läden.</li>
  </ol>
  <p>Bitte wähle die Menge der Produkte und einen Grund für die Rückgabe aus.</p>
  @if (errorMessage()) {
    <div class="row">
      <div class="col-xs-12 mb-3">
        <div class="p-3 msg-error">{{ errorMessage() }}</div>
      </div>
    </div>
  }

  <div class="items-wrapper">
    @for (item of items(); track item.id) {
      <div class="item d-flex">
        <div class="image flex-fill">
          @if (item.distinctProduct.product.getListImageSlug(item.distinctProduct.selectedVariant)) {
            <img
              [ngSrc]="item.distinctProduct.product.getListImageSlug(item.distinctProduct.selectedVariant) + ''"
              alt="{{ item.distinctProduct.product.getListPicture()?.alt }}"
              ngSrcset="200w, 300w, 400w, 750w"
              fill
              class="img-fluid"
            />
          }
        </div>
        <div class="info flex-fill px-3 py-3 d-flex flex-column">
          <strong class="title">{{ getTitle(item) }}</strong>
          @let attrList = item.getSelectedAttributeList();
          @let dimList = item.getSelectedDimensionsList();
          <div class="attributes">
            @for (attr of attrList; track attr.code + '|' + attr.label; let i = $index) {
              {{ attr.label }}: {{ attr.value }}{{ attr.unit ? ' ' + attr.unit : '' }}{{ ( i+1 < attrList.length ) ? ', ' : ''}}
            }
            @for (attr of dimList; track attr.code + '|' + attr.label; let i = $index) {
              {{ attr.label }}: {{ attr.value }}{{ attr.unit ? ' ' + attr.unit : '' }}{{ ( i+1 < dimList.length ) ? ', ' : ''}}
            }
          </div>

          @if (isRefundable(item)) {
              <div class="quantity mt-auto">
                <div class="input-group">
                  <div class="select-wrapper">
                    <select class="form-control" [value]="selectedAmounts[item.id]"
                            (change)="setAmount(item, +$any($event.target).value)">
                      @for (amount of getAmountOptions(item); track amount) {
                        <option [value]="amount">{{ amount }}</option>
                      }
                    </select>
                  </div>
                </div>
              </div>
            <div class="reason-select mt-3">
              <div class="input-group">
                <div class="select-wrapper">
                  <select class="form-control"
                          (change)="setReason(item, +$any($event.target).value)">
                    <option value="" disabled [selected]="! selectedReasons[item.id]">Bitte Grund auswählen ...</option>
                    @for (reason of refundReasons(); track reason.reason) {
                      <option [value]="reason.id" [selected]="selectedReasons[item.id] === reason.id">{{ reason.reason }}</option>
                    }
                  </select>
                </div>
              </div>
            </div>
          } @else {
            <p class="hint txt-red mb-0">
              <strong>Der Artikel wurde bereits zurückgegeben.</strong><br>Grund:
            @if (item.returnReason) {
              {{ item.returnReason }}
            } @else {
              Dieses Produkt kann nicht zurückgegeben werden
            }
            </p>
          }
        </div>
      </div>
    }
  </div>
  <div class="name-fields mt-3 row" [formGroup]="nameForm">
    <div class="col-xs-12 col-md-6 mb-3">
      <label class="form-label">Vorname</label>
      <span class="input-wrap" [class.invalid]="nameForm.controls['firstname'].invalid && nameForm.controls['firstname'].touched"
        [class.valid]="nameForm.controls['firstname'].valid && nameForm.controls['firstname'].touched"
        >
        <input placeholder="Vorname" type="text" class="form-control" formControlName="firstname">
      </span>
      <show-form-error text="Vorname" path="firstname"></show-form-error>
    </div>
    <div class="col-xs-12 col-md-6 mb-3">
      <label class="form-label">Nachname</label>
      <span class="input-wrap" [class.invalid]="nameForm.controls['lastname'].invalid && nameForm.controls['lastname'].touched"
        [class.valid]="nameForm.controls['lastname'].valid && nameForm.controls['lastname'].touched"
        >
        <input placeholder="Nachname" type="text" class="form-control" formControlName="lastname">
      </span>
      <show-form-error text="Nachname" path="lastname"></show-form-error>
    </div>
  </div>
  <p>
    Wenn Sie diese Online-Funktion nutzen, übermitteln wir Ihnen unverzüglich eine Eingangsbestätigung mit Informationen zum Inhalt der
    Widerrufserklärung per Email (dauerhaftem Datenträger), inkl. Datum und der Uhrzeit ihres Eingangs.
    Anschließend prüfen wir Ihre Widerrufserklärung!
  </p>
  <button type="button" class="btn btn-green mt-3" [disabled]="loading() || ! canSubmit()" (click)="submitRefund()">
    @if (loading()) {
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    }
    Widerruf abschicken
  </button>
}
